import { ContentfulMultiColumnBlock } from '@jbhi-fi/apis/src/contentful/types';
import { MultiColumnBlockProps } from '../../MultiColumnBlock/MultiColumnBlock';
import { MultiColumnEntryTransformer } from './MultiColumnEntryTransformer';
import { ThemeTransformer } from './ThemeTransformer';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

export abstract class MultiColumnBlockTransformer {
  static toMultiColumnBlockProps = (entry: ContentfulMultiColumnBlock): MultiColumnBlockProps => {
    return {
      heading: entry.fields?.heading ?? '',
      alignment: entry.fields?.contentAlignment ?? 'Left',
      desktopColumns: entry.fields?.desktopColumns ?? 3,
      mobileFormat: entry.fields?.mobileFormat ?? 'Stack',
      entries: entry.fields?.entries?.map(MultiColumnEntryTransformer.toMultiColumnEntryProps) ?? [],
      theme: ThemeTransformer.toContentThemePalette(entry.fields?.themeColour) ?? {
        background: palette.primary.light,
        text: palette.primary.dark,
      },
    };
  };
}
